import { render, staticRenderFns } from "./We.vue?vue&type=template&id=4aa4c7e4&scoped=true"
import script from "./We.vue?vue&type=script&lang=js"
export * from "./We.vue?vue&type=script&lang=js"
import style0 from "./We.vue?vue&type=style&index=0&id=4aa4c7e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4c7e4",
  null
  
)

export default component.exports